import { render, staticRenderFns } from "./newDeviceRegistration.vue?vue&type=template&id=66802c8c&scoped=true&lang=pug&"
import script from "./newDeviceRegistration.vue?vue&type=script&lang=js&"
export * from "./newDeviceRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66802c8c",
  null
  
)

export default component.exports